import Flickity from 'flickity-imagesloaded';
import enquire from 'enquire.js';
import { breakpoints } from '../utils';

const carousels = Array.from(document.querySelectorAll('.js-icon-slider'));
let flkty;

const options = {
    cellSelector: '.icon-slider__group',
    prevNextButtons: false,
    pageDots: false,
    imagesLoaded: true,
    cellAlign: 'center',
    wrapAround: true,
};

if (carousels) {
    carousels.forEach((carousel) => {
        const nextButton = carousel.querySelector('.js-next');

        enquire.register(breakpoints['lap-and-up'], {

            match() {
                flkty = new Flickity(carousel, options);

                if (nextButton) {
                    nextButton.addEventListener('click', () => {
                        flkty.next();
                    });
                }
            },

            unmatch() {
                flkty.destroy();
            },

        });
    });
}
